const initialState = {
    isBackdropLoading: false,
};

const allLoaders = (state = initialState, action) => {
    switch (action.type) {

        case 'SET_BACKDROP_LOADING':
            return {...state, isBackdropLoading:  action.isLoading};
        
        
        default:
            return state;
    }
};

export default allLoaders;
